export default __webpack_public_path__ + "static/media/Adam.a6b3297f.svg";